




































































import { Invoice } from '@accounting/interfaces/invoice';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-invoice-pdf-header',
  components: {},
})
export default class InvoicePdfHeader extends Vue {
  @Prop(Object) readonly invoice: Invoice;
  @Prop(String) readonly invoiceCode: string;
  get invoiceText(): string {
    return 'global.invoice_type.' + this.invoice.invoice_type;
  }
  get invoiceDateText(): string {
    if (this.invoice.invoice_type == 'ticket') {
      return 'global.ticket_date.label';
    } else if (this.invoice.invoice_type == 'invoice') {
      return 'global.invoice_date.label';
    } else {
      return 'global.date.label';
    }
  }
  get invoiceCodeString(): string {
    // return this.invoice.code ? '# ' + this.invoiceCode : this.invoiceCode;
    return this.invoice.document_number
      ? '# ' + this.invoice.document_number
      : '# ' + this.invoiceCode;
  }

  get contactCodeString(): string {
    return '# ' + this.invoice.contact?.code;
  }
  get canShowLogo(): boolean {
    const hasLogo =
      this.invoice &&
      this.invoice.center &&
      this.invoice.center.logo_url &&
      this.invoice.center.logo_url.url;
    const supportedExtensions = ['jpg', 'jpeg', 'gif', 'png'];
    let hasGoodExtension = false;
    if (hasLogo) {
      const extension = this.invoice.center.logo_url.url.split('.').pop();
      hasGoodExtension = supportedExtensions.includes(extension);
    }

    return hasLogo && hasGoodExtension;
  }

  formatDate(date) {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
  }
}
